import React, { useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { useDispatch } from 'react-redux';
import * as turf from '@turf/turf';

interface IProps {
  address?: any;
  latitude: any;
  longitude: any;
  setLatitude: any;
  setLongitude: any;
  radius?: any;
  showMarker?: boolean;
  hideSearchBar?: boolean;
}

const MapContainer: React.FC<IProps> = ({
  address,
  latitude,
  longitude,
  setLatitude,
  setLongitude,
  radius,
  showMarker,
  hideSearchBar,
}) => {
  const [lnglat, setLngLat] = useState<any>([0, 0]);
  const [map, setMap] = useState<any>(null);
  const [marker, setMarker] = useState<any>(null);
  //   const [latitude, setLatitude] = useState<any>(
  //     address?.address?.coordinates?.latitude
  //   );
  //   const [longitude, setLongitude] = useState<any>(
  //     address?.address?.coordinates?.longitude
  //   );
  const dispatch = useDispatch();

  useEffect(() => {
    if (address) {
      setLatitude(address?.address?.coordinates?.latitude || 27.7082300426369);
      setLongitude(
        address?.address?.coordinates?.longitude || 85.32061225956755
      );
    }
  }, [address?.address]);

  useEffect(() => {
    const mapContainer = document.getElementById('map');
    if (!mapContainer) {
      return;
    }
    if (typeof latitude !== 'number' || typeof longitude !== 'number') {
      console.error('Invalid latitude or longitude');
      return;
    }

    mapboxgl.accessToken =
      'pk.eyJ1Ijoibm92dXMtZnNpbmMiLCJhIjoiY2xvZHYycmlzMDJ2ZTJpazFpZGpjc3NubiJ9.NZZAjphfCX4XzMRsHjG9_Q';

    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [longitude, latitude],
      zoom: 12,
    });

    map.on('load', function () {
      const center = turf.point([longitude, latitude]);
      const options: any = { steps: 100, units: 'kilometers' };
      const circleData = turf.circle(center, radius / 1000, options);

      map.flyTo({
        center: [longitude, latitude],
        essential: true,
      });

      map.addSource('circleCenter', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [longitude, latitude],
              },
              properties: {},
            },
          ],
        },
      });

      map.addSource('circle', {
        type: 'geojson',
        data: circleData,
      });

      map.addLayer({
        id: 'circleLayer',
        type: 'fill',
        source: 'circle',
        paint: {
          'fill-color': '#007cbf',
          'fill-opacity': 0.5,
        },
      });
    });

    const markerData = new mapboxgl.Marker({
      draggable: showMarker ? true : false,
    })
      .setLngLat([longitude, latitude])
      .addTo(map);

    markerData.on('dragend', function () {
      const lngLat = markerData.getLngLat();
      setLatitude(lngLat.lat);
      setLongitude(lngLat.lng);
    });

    setMarker(markerData);
    setMap(map);

    if (!hideSearchBar) {
      const geocoder = new MapboxGeocoder({
        // accessToken:'pk.eyJ1Ijoibm92dXMtZnNpbmMiLCJhIjoiY2xvZHYycmlzMDJ2ZTJpazFpZGpjc3NubiJ9.NZZAjphfCX4XzMRsHjG9_Q',
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
      });

      map.addControl(geocoder);

      geocoder.on('result', function (e) {
        markerData.setLngLat(e.result.geometry.coordinates);
        setLatitude(e.result.geometry.coordinates[1]);
        setLongitude(e.result.geometry.coordinates[0]);
      });
    }
  }, [latitude, longitude]);

  // function metersToPixelsAtMaxZoom(meters: any, latitude: number) {
  //   return meters / Math.cos((latitude * Math.PI) / 180);
  // }
  return (
    <>
      <div
        className="mb-5 border border-border-color"
        id="map"
        style={{ width: '100%', height: '340px' }}
      ></div>
    </>
  );
};

export default MapContainer;
